import iconWhite from "@/assets/logo-icon-white.png";
import iconDark from "@/assets/logo-icon-dark.png";
import lockupWhite from "@/assets/logo-full-white.png";

const S = { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };
const RED = "#D62828";

export const BrandIcon = ({ className, dark }) => (
  <img src={dark ? iconDark : iconWhite} alt="Stronghold Bakery" className={className} />
);

export const BrandLockup = ({ className }) => (
  <img src={lockupWhite} alt="Stronghold Bakery" className={className} />
);

export const ShelfArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <path d="M18 32h164l-10-20H28z" />
    <path d="M18 32q10 12 20 0q10 12 21 0q10 12 20 0q11 12 21 0q10 12 20 0q10 12 21 0q10 12 20 0q10 12 21 0" />
    <path d="M52 12l-6 20M77 12l-3 20M102 12v20M127 12l3 20M152 12l6 20" />
    <path d="M28 44v86M172 44v86M12 130h176" />
    <path d="M34 78h132M34 112h132" strokeWidth="4" />
    <path d="M42 78q0-18 19-18t19 18" /><path d="M51 67l4-4M60 65l4-4M68 67l4-4" />
    <circle cx="102" cy="67" r="10" /><circle cx="102" cy="67" r="3" />
    <path d="M124 78q0-13 13-13h12q13 0 13 13" /><path d="M134 70l3-3M143 69l3-3" />
    <ellipse cx="62" cy="108" rx="20" ry="3" /><ellipse cx="62" cy="103" rx="20" ry="3" /><ellipse cx="62" cy="98" rx="20" ry="3" />
    <path d="M104 110q8-17 22-10q14-7 22 10" /><path d="M116 104l2-6M126 101v-6M136 104l-2-6" />
    <circle cx="160" cy="54" r="4" fill={RED} stroke="none" />
  </svg>
);

export const OvenArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <rect x="38" y="14" width="124" height="104" rx="8" />
    <path d="M38 36h124" />
    <circle cx="54" cy="25" r="4" /><circle cx="68" cy="25" r="4" /><circle cx="146" cy="25" r="4" fill={RED} stroke="none" />
    <rect x="52" y="46" width="96" height="58" rx="5" />
    <path d="M60 92h80" strokeWidth="3" />
    <path d="M66 92q0-12 13-12t13 12" /><path d="M100 92q0-12 13-12t13 12" />
    <path d="M78 70q4-4 0-8t0-8M100 70q4-4 0-8t0-8M122 70q4-4 0-8t0-8" stroke={RED} />
    <path d="M70 110h60" strokeWidth="3" />
    <rect x="22" y="124" width="56" height="9" rx="4.5" /><path d="M12 128.5h10M78 128.5h10" />
    <path d="M130 130h50" /><path d="M140 130v-6h30v6" />
  </svg>
);

export const BinArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <path d="M62 42h76l-9 86H71z" />
    <path d="M52 42h96" strokeWidth="3" />
    <path d="M86 42v-9h28v9" />
    <path d="M84 56l2 60M100 56v60M116 56l-2 60" />
    <path d="M128 26q0-14 15-14t15 14" transform="rotate(18 143 20)" />
    <path d="M140 14l3-3M148 16l3-3" transform="rotate(18 143 20)" />
    <circle cx="40" cy="120" r="2.5" fill={RED} stroke="none" /><circle cx="160" cy="118" r="2" fill={RED} stroke="none" />
    <circle cx="150" cy="128" r="1.6" fill={RED} stroke="none" /><circle cx="48" cy="130" r="1.6" fill="currentColor" stroke="none" />
    <path d="M30 134h140" />
  </svg>
);

export const RegisterArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <rect x="66" y="12" width="64" height="24" rx="3" />
    <path d="M78 24h16" stroke={RED} />
    <path d="M98 36v8" />
    <path d="M48 76l12-32h76l12 32" />
    <circle cx="76" cy="56" r="2.5" /><circle cx="90" cy="56" r="2.5" /><circle cx="104" cy="56" r="2.5" /><circle cx="118" cy="56" r="2.5" />
    <circle cx="72" cy="66" r="2.5" /><circle cx="86" cy="66" r="2.5" /><circle cx="100" cy="66" r="2.5" /><circle cx="124" cy="66" r="2.5" fill={RED} stroke="none" />
    <rect x="30" y="76" width="140" height="48" rx="4" />
    <path d="M30 100h140M88 112h24" />
    <path d="M150 74V40h26v38l-4-3-4 3-5-3-4 3-5-3-4 3" /><path d="M156 50h14M156 58h14M156 66h8" />
  </svg>
);

export const CrateArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <rect x="44" y="64" width="124" height="62" rx="3" />
    <path d="M44 85h124M44 105h124M66 64v62M146 64v62" />
    <path d="M74 64V30h64v34" /><path d="M106 30v34" stroke={RED} strokeWidth="3" />
    <path d="M74 30l10-12h44l10 12" />
    <path d="M10 46h34m-8-7 8 7-8 7" stroke={RED} />
    <path d="M24 132h160" />
  </svg>
);

export const ClipboardArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <rect x="58" y="18" width="88" height="116" rx="7" />
    <rect x="82" y="10" width="40" height="16" rx="4" />
    <path d="M72 50l6 6 10-11" /><path d="M96 51h36" />
    <path d="M72 74l6 6 10-11" /><path d="M96 75h36" />
    <path d="M72 98l6 6 10-11" stroke={RED} /><path d="M96 99h24" />
    <path d="M160 40l14 14-34 34h-14V74z" /><path d="M154 46l14 14" />
  </svg>
);

export const LedgerArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <path d="M16 30q42-12 84 6q42-18 84-6v92q-42-12-84 6q-42-18-84-6z" />
    <path d="M100 36v92" />
    <path d="M32 52h52M32 66h52M32 80h40M32 94h52" />
    <path d="M116 52h52M116 66h30M116 80h52M116 94h40" />
    <path d="M150 66h18" stroke={RED} strokeWidth="3" />
  </svg>
);

export const ChartArt = ({ className }) => (
  <svg viewBox="0 0 200 140" className={className} aria-hidden="true" {...S}>
    <path d="M24 16v110h160" />
    <rect x="44" y="76" width="20" height="50" /><rect x="76" y="56" width="20" height="70" />
    <rect x="108" y="88" width="20" height="38" /><rect x="140" y="40" width="20" height="86" />
    <path d="M40 66l36-24 32 30 40-46" stroke={RED} />
    <circle cx="148" cy="26" r="4" fill={RED} stroke="none" />
  </svg>
);

const ICONS = {
  Roti: (
    <><path d="M3 15a9 7 0 0 1 18 0v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" /><path d="M8 11l2-2M12 10l2-2M16 11l1.5-1.5" /></>
  ),
  Bagel: (<><circle cx="12" cy="12" r="8.5" /><circle cx="12" cy="12" r="2.5" /><path d="M7 8l.6.6M15.5 6.8l.6.6M16.5 15l.6.6M7.5 15.6l.6.6" /></>),
  Bundle: (<><circle cx="8" cy="13" r="5" /><circle cx="8" cy="13" r="1.4" /><circle cx="16" cy="11" r="5" /><circle cx="16" cy="11" r="1.4" /></>),
  Tortilla: (<><ellipse cx="12" cy="8" rx="9" ry="3" /><path d="M3 8v3.5a9 3 0 0 0 18 0V8" /><path d="M3 11.5V15a9 3 0 0 0 18 0v-3.5" /></>),
  "Frozen Dough": (<><path d="M3.5 17q0-6 8.5-6t8.5 6q0 3-8.5 3t-8.5-3z" /><path d="M12 2v6M9.4 3.5l5.2 3M14.6 3.5l-5.2 3" /></>),
  Supplier: (<><path d="M3 8l9-5 9 5v8l-9 5-9-5z" /><path d="M3 8l9 5 9-5M12 13v8" /></>),
};

export const ProductIcon = ({ category, bundle, className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    {ICONS[bundle ? "Bundle" : category] || ICONS.Supplier}
  </svg>
);
